<!-- begin::User -->
<div
  class="d-flex align-items-center"
  [ngClass]="toolbarButtonMarginClass"
  id="kt_header_user_menu_toggle"
>
  <app-user-trigger-inner
    data-kt-menu-target="#kt_header_user_menu"
    data-kt-menu-trigger="click"
    data-kt-menu-attach="parent"
    data-kt-menu-placement="bottom-end"
    data-kt-menu-flip="bottom"
  >
    <span
      class="cursor-pointer svg-icon svg-icon-1 topbar__settings"
      inlineSVG="./assets/media/icons/app/settings.svg"
    ></span>
  </app-user-trigger-inner>
  <app-user-inner id="kt_header_user_menu"></app-user-inner>
</div>
<!-- end::User -->

<!-- @todo Remove hidden via false when this menu will be needed -->
<ng-container *ngIf="headerLeft === 'menu' && false">
  <div
    class="d-flex align-items-center d-lg-none ms-2 me-n3"
    title="Show header menu"
  >
    <div
      class="
        btn btn-icon btn-active-light-primary
        w-30px
        h-30px
        w-md-40px
        h-md-40px
      "
      id="kt_header_menu_mobile_toggle"
    >
      <span
        [inlineSVG]="'./assets/media/icons/duotune/text/txt001.svg'"
        class="svg-icon svg-icon-1"
      ></span>
    </div>
  </div>
</ng-container>
